<template>
  <div v-if="video" class="player">
     <div class="player-outer-wrapper">
    <div class="player-inner-wrapper" :class="orientationClass" :style="orientationStyle">
      <video ref="video" v-videojs="setPlayer" :style="orientationStyle">
        <source :src="video" />
      </video>
      <div v-if="loaded" class="tag-layer">
        <slot name="overlay" />
      </div>
    </div>
     </div>
    <slot name="toolbar" v-on:mute="onMute" :player="player">
    </slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import videojs from 'video.js'
  import 'video.js/dist/video-js.min.css'

  export default {
    name: 'player',
    props: ['video'],

    data: () => ({
      player: null,
      loaded: false,
      time: null
    }),
    computed: {
      ...mapState({videoState: 'video'}),
      orientationClass() {
         return this.videoState.meta.height > this.videoState.meta.width ? 'is-portrait-orientation' : 'is-landscape-orientation'
      },
      orientationStyle() {
        let isPortrait = this.videoState.meta.height > this.videoState.meta.width
        let so = {
            width: '100%',
            height: 'auto'
          }
        if (isPortrait) {
          so.width = 'initial',
          so.height = '100%'
        }
        return so
      }
    },
    methods: {
      setPlayer(player) {
        this.player = player
        this.$emit('ready', player)
        player.on('loadedmetadata', () => { 
          this.loaded = true
          this.$emit('loaded', true)
        })
        player.on('timeupdate', () => { this.time = player.currentTime() })
      },
      onSpace: function () {
        this.player.paused() ? this.player.play() : this.player.pause()
      },
      onResize() {
        const bb = this.$el.querySelector('video').getBoundingClientRect()
        this.videoState.dimensions = {
          width: bb.width,
          height: bb.height
        }
      },
 
   },

    mounted() {
      // document.addEventListener('keydown', this.onKeyDown)
      window.addEventListener('resize', this.onResize)

      this.$on('mute', () => {
        this.$refs.video.muted = !this.$refs.video.muted
      })
    },
    beforeDestroy() {
      // document.removeEventListener('keydown', this.onKeyDown)
      window.removeEventListener('resize', this.onResize)
    },
    directives: {
      videojs: {
        bind(e, binding) {
          var player = videojs(e, {
            preload: 'auto',
            autoplay: false,
            loop: false,
            muted: false,
            fluid: true
          })
          player.on('ready', () => {
            videojs.log('player ready')
          })
          if (typeof binding.value === 'function') {
            binding.value(player)
          }
        }
      }
    },
    watch: {
      time (time) {
        this.$emit('timeupdate', time)
      },
      loaded() {
        const bb = this.$el.querySelector('video').getBoundingClientRect()
        this.videoState.dimensions = {
          width: bb.width,
          height: bb.height
        }
      }
    }
  }

</script>
